<div class="main-content">
  <div class="contactus-main">
    <h1>Contact Us</h1>
    <div class="container" *ngIf="contactData">
      <div class="information">
        <div class="row align-items-center">
          <div class="col-12 col-md-4">
            <h2>Support information</h2>
          </div>
          <ng-container *ngFor="let office of contactData.offices">
            <div class="col-12 col-md-4">
              <div class="information-main">
                <img loading="lazy" [src]="environment?.blobUrl + '/assets/images/contact-us/location.svg'" alt="Location | Luminous">
                <h4>{{office.type}}</h4>
                <h5>{{office.name}}</h5>
                <p>{{office.address}}</p>
                <a [href]="office.mapLink" target="_blank" class="arrow">View on Map</a>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <app-help-support></app-help-support>
  </div>
</div>